angular.module('Mineler').run(['$templateCache', function($templateCache) {
  $templateCache.put('map/panels/profile/profile-add-resume.tpl.html',
    '<div id="map-panel-profile-edit" class="map-secondary-panel"\n' +
    '     ng-controller="ProfileAddResumeCtrl as addResume" ng-swipe-left="addResume.closeEditPanel()" ng-swipe-disable-mouse>\n' +
    '  <div class="row map-panel-heading">\n' +
    '    <div class="small-2 columns">\n' +
    '      <a class="arrow-back" ng-click="addResume.closeEditPanel()">\n' +
    '        <i class="fa fa-angle-double-left"></i>\n' +
    '      </a>\n' +
    '    </div>\n' +
    '    <div class="small-13 columns">\n' +
    '      <h3>Upload My Resume</h3>\n' +
    '    </div>\n' +
    '  </div>\n' +
    '\n' +
    '  <div class="row profile-edit">\n' +
    '    <div class="small-15 columns">\n' +
    '      <form name="addResumeForm" role="addResumeForm">\n' +
    '        <div class="row">\n' +
    '          <div class="small-15 columns">\n' +
    '            <input type="text" name="name" ng-model="addResume.data.name" ng-required="true"\n' +
    '                   placeholder="My Resume"/>\n' +
    '          </div>\n' +
    '        </div>\n' +
    '        <div class="row">\n' +
    '          <div class="small-15 columns">\n' +
    '            <span ng-hide="addResume.selectedFile" class="custom-file-upload-button" ng-file-select="addResume.onFileSelect($files)" ng-required="true"><i class="fa fa-paperclip"></i> Select a file to upload</span>\n' +
    '            <span ng-show="addResume.selectedFile">{{addResume.selectedFile.name}}<a ng-click="addResume.removeFile()" ng-hide="addResume.isSaving"> <i class="fa fa-close"></i></a></span>\n' +
    '          </div>\n' +
    '        </div>\n' +
    '        <div class="row">\n' +
    '          <div class="small-10 columns">\n' +
    '            <small class="profile-edit-error" ng-show="addResume.editProfileErrorMessage">{{addResume.editProfileErrorMessage}}</small>\n' +
    '          </div>\n' +
    '          <div class="small-5 columns profile-edit-button-container">\n' +
    '            <span us-spinner="{radius:3, width:3, length: 8, color: \'#ffffff\'}" spinner-key="spinner-profile-edit"></span>\n' +
    '            <button ng-hide="addResume.isSaving" class="right button positive" ng-click="addResume.save()"ng-disabled=\'addResumeForm.$invalid || !addResume.selectedFile\'>Upload</button>\n' +
    '          </div>\n' +
    '        </div>\n' +
    '      </form>\n' +
    '    </div>\n' +
    '  </div>\n' +
    '</div>\n' +
    '');
}]);
